<template>
  <div class="row">
    <label class="col-md-2 control-label" for="viewmode">Set Mode</label>
    <div class="col-md-3">
      <div class="input-group">
        <button
            id="viewmode"
            type="button"
            class="btn btn-md btn-green"
            @click="onClick($event)"
        >
          {{ btnName }}
        </button>
        <modal-help>
          Click the mode button if the offering is not open for investment.
          Investors will see the offering media and be able to click the Learn More button.
        </modal-help>
      </div>
    </div>
    <h5 v-show="isVisible">{{ message }}</h5>
  </div>
</template>

<script>
  import axios from 'axios'
  import ModalHelp from "./ModalHelp"

  export default {
    components: {
      ModalHelp
    },
    props: [
        'slug',
        'offeringViewMode',
        'offeringId'
    ],
    data() {
      return {
        isVisible: true,
        message: '',
        newViewMode: this.offeringViewMode,
        postData: {
          offering: this.offeringId,
          newOfferingViewMode: ''
        }
      }
    },
  computed: {
    btnName() {
     return this.newViewMode === '1' ? 'Open for Investment' : 'Learn More'
    }
  },
    created() {
      this.newViewMode = this.offeringViewMode

    },
    methods: {
      updateOfferingViewMode() {
        axios.post('viewMode',this.postData)
            .then(response => {
              this.message = response.data.status
              return Promise.resolve()
            })
      },
      onClick(event) {
        event.preventDefault()
        this.isVisible = true
        this.newViewMode = this.newViewMode === '1' ? '0' : '1'
        this.postData.newOfferingViewMode = this.newViewMode
        this.updateOfferingViewMode()
        this.timer()
      },
      timer() {
        setTimeout(() => {
          this.isVisible = false
          this.message = ''
        }, 3000)
      }
    }
  }
</script>